import { Style } from "./Style";

let defaultStyle;

export class CheckboxStyle extends Style {
    static get DEFAULT() {
        return defaultStyle || (defaultStyle = new CheckboxStyle);
    }
    constructor(style = {}, headerStyle = {}, checkboxThemeStyle = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        super(style, headerStyle), this._size = (null !== (_b = null !== (_a = null == style ? void 0 : style.size) && void 0 !== _a ? _a : null == headerStyle ? void 0 : headerStyle.size) && void 0 !== _b ? _b : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.size) || 14, 
        this._spaceBetweenTextAndIcon = (null !== (_d = null !== (_c = null == style ? void 0 : style.spaceBetweenTextAndIcon) && void 0 !== _c ? _c : null == headerStyle ? void 0 : headerStyle.spaceBetweenTextAndIcon) && void 0 !== _d ? _d : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.spaceBetweenTextAndIcon) || 8, 
        this._defaultFill = null !== (_f = null === (_e = null == style ? void 0 : style.checkboxStyle) || void 0 === _e ? void 0 : _e.defaultFill) && void 0 !== _f ? _f : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.defaultFill, 
        this._defaultStroke = null !== (_h = null === (_g = null == style ? void 0 : style.checkboxStyle) || void 0 === _g ? void 0 : _g.defaultStroke) && void 0 !== _h ? _h : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.defaultStroke, 
        this._disableFill = null !== (_k = null === (_j = null == style ? void 0 : style.checkboxStyle) || void 0 === _j ? void 0 : _j.disableFill) && void 0 !== _k ? _k : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.disableFill, 
        this._checkedFill = null !== (_m = null === (_l = null == style ? void 0 : style.checkboxStyle) || void 0 === _l ? void 0 : _l.checkedFill) && void 0 !== _m ? _m : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.checkedFill, 
        this._checkedStroke = null !== (_p = null === (_o = null == style ? void 0 : style.checkboxStyle) || void 0 === _o ? void 0 : _o.checkedStroke) && void 0 !== _p ? _p : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.checkedStroke, 
        this._disableCheckedFill = null !== (_r = null === (_q = null == style ? void 0 : style.checkboxStyle) || void 0 === _q ? void 0 : _q.disableCheckedFill) && void 0 !== _r ? _r : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.disableCheckedFill, 
        this._disableCheckedStroke = null !== (_t = null === (_s = null == style ? void 0 : style.checkboxStyle) || void 0 === _s ? void 0 : _s.disableCheckedStroke) && void 0 !== _t ? _t : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.disableCheckedStroke, 
        this._checkIconImage = null !== (_v = null === (_u = null == style ? void 0 : style.checkboxStyle) || void 0 === _u ? void 0 : _u.checkIconImage) && void 0 !== _v ? _v : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.checkIconImage, 
        this._indeterminateIconImage = null !== (_x = null === (_w = null == style ? void 0 : style.checkboxStyle) || void 0 === _w ? void 0 : _w.indeterminateIconImage) && void 0 !== _x ? _x : null == checkboxThemeStyle ? void 0 : checkboxThemeStyle.indeterminateIconImage;
    }
    get size() {
        return this._size;
    }
    set size(size) {
        this._size = size;
    }
    get spaceBetweenTextAndIcon() {
        return this._spaceBetweenTextAndIcon;
    }
    set spaceBetweenTextAndIcon(spaceBetweenTextAndIcon) {
        this._spaceBetweenTextAndIcon = spaceBetweenTextAndIcon;
    }
    get defaultFill() {
        return this._defaultFill;
    }
    set defaultFill(defaultFill) {
        this._defaultFill = defaultFill;
    }
    get defaultStroke() {
        return this._defaultStroke;
    }
    set defaultStroke(defaultStroke) {
        this._defaultStroke = defaultStroke;
    }
    get disableFill() {
        return this._disableFill;
    }
    set disableFill(disableFill) {
        this._disableFill = disableFill;
    }
    get checkedFill() {
        return this._checkedFill;
    }
    set checkedFill(checkedFill) {
        this._checkedFill = checkedFill;
    }
    get checkedStroke() {
        return this._checkedStroke;
    }
    set checkedStroke(checkedStroke) {
        this._checkedStroke = checkedStroke;
    }
    get disableCheckedFill() {
        return this._disableCheckedFill;
    }
    set disableCheckedFill(disableCheckedFill) {
        this._disableCheckedFill = disableCheckedFill;
    }
    get disableCheckedStroke() {
        return this._disableCheckedStroke;
    }
    set disableCheckedStroke(disableCheckedStroke) {
        this._disableCheckedStroke = disableCheckedStroke;
    }
    get checkIconImage() {
        return this._checkIconImage;
    }
    set checkIconImage(checkIconImage) {
        this._checkIconImage = checkIconImage;
    }
    get indeterminateIconImage() {
        return this._indeterminateIconImage;
    }
    set indeterminateIconImage(indeterminateIconImage) {
        this._indeterminateIconImage = indeterminateIconImage;
    }
    getStyle(style) {
        return new CheckboxStyle(style, this);
    }
    clone() {
        return new CheckboxStyle(this);
    }
}
//# sourceMappingURL=CheckboxStyle.js.map
